UploadStudentTeacher = new (function () {
  let wrapper;
  this.setSelects = () => {
    if (!wrapper || !wrapper.length) return;

    // Set selects
    $("#uploads_student_teacher_calendar_year", wrapper).select2({
      placeholder: "Calendar year",
    });

    $("#student_teacher_teacher_id", wrapper).select2({
      placeholder: "- Select -",
    });

    $("#student_teacher_subject", wrapper).select2({
      placeholder: "- Select -",
    });

    $("#student_teacher_student_id", wrapper).select2({
      placeholder: "- Select -",
      ajax: { dataType: "json", url: "/student_entities/autocomplete", delay: 250 },
    });
  };

  this.initForm = () => {
    wrapper = $(".upload_student_teacher_wrapper");
    if (!wrapper || !wrapper.length) return;
    Shared.applyFileValidation({
      fileSelector: "#uploads_student_teacher_file",
      submitSelector: ".upload_student_teacher_wrapper button[type='submit']",
    });
  };
})();
